import React from 'react';
import { Routes, Route} from 'react-router-dom';

import Navbar from '../components/admin/navigation-bar/Navbar';
import Dashboard from '../components/admin/dashboard/Dashboard';
import ViewProfile from '../components/admin/admin-view-profile/ViewProfile';
import ClientList from '../components/admin/client-list/ClientList';
import AddEmployee from '../components/admin/add-employee/AddEmployee';
import ActiveEmployee from '../components/admin/employee/ActiveEmployee';
import InactiveEmployee from '../components/admin/employee/InactiveEmployee';
import ClientCandidates from '../components/admin/clients-candidates/ClientCandidates';
import AdminServiceHandle from '../components/service-down/AdminServiceHandle';
import AssignedCandidates from '../components/admin/employee-candidates/AssignedCandidates';
import CandidateReport from '../components/admin/reports/CandidateReport';
import CandidateDetails from '../components/admin/candidate-details/CandidateDetails';



const AdminRoutes = () => {
  return (
    <Routes>
      {/* Wrapping all routes with Navbar layout */}
      <Route path="/" element={<Navbar />}>
        <Route index element={<Dashboard />} /> {/* /admin */}
        <Route path="dashboard" element={<Dashboard />} /> {/* /admin/dashboard */}
        <Route path="view-profile" element={<ViewProfile />} /> {/* /admin/view-profile */}
        <Route path="clients" element={<ClientList searchTerm="" />} /> {/* /admin/clients */}
        <Route path="add-employee" element={<AddEmployee />} /> {/* /admin/add-employee */}
        <Route path="active-employee" element={<ActiveEmployee searchTerm="" />} /> {/* /admin/active-employee */}
        <Route path="inactive-employee" element={<InactiveEmployee searchTerm="" />} /> {/* /admin/inactive-employee */}
        <Route path="client/:clientId/candidates" element={<ClientCandidates />} /> {/* /admin/client/123/candidates */}
        <Route path="employee/:employeeId/candidates" element={<AssignedCandidates />} />
        <Route path="reports/:candidateId" element={<CandidateReport />} />
        <Route path="candidate-details/:candidateId" element={<CandidateDetails />} />

                <Route path="service-down" element={<AdminServiceHandle />} />

      </Route>
    </Routes>
  );
};

export default AdminRoutes;
